function getClientLocale() {
  if (typeof Intl !== 'undefined') {
    try {
      return Intl.NumberFormat().resolvedOptions().locale;
    } catch (err) {
      return navigator.languages && navigator.languages.length
        ? navigator.languages[0]
        : navigator.language;
    }
  }
}

const timeFormatter = (timezone) => {
  return new Intl.DateTimeFormat(getClientLocale(), {
    timeStyle: 'long',
    dateStyle: 'short',
    timeZone: timezone,
  });
};

const dateOnlyFormatter = (timezone) => {
  return new Intl.DateTimeFormat(getClientLocale(), {
    dateStyle: 'short',
    timeZone: timezone,
  });
};

export const getLocalTimeZone = () => {
  return new Intl.DateTimeFormat(getClientLocale()).resolvedOptions().timeZone;
};

export const getDateFormatFromImageJSON = (imageJson) => {
  const datetimeTimestamp = imageJson.main.date_taken_milliseconds;
  let user_timezone = imageJson.main.user_timezone;
  const date = new Date(datetimeTimestamp);
  if (user_timezone === undefined || user_timezone === null) {
    user_timezone = 'UTC';
  }
  return timeFormatter(user_timezone).format(date);
};

export const getDateTimeFromMillisecondsTZ = (dateInMilliSec, timezone) => {
  const date = new Date(dateInMilliSec || 0);
  if (timezone === undefined || timezone === null) {
    timezone = 'UTC';
  }
  return timeFormatter(timezone).format(date);
};

export const getDateWithTimeZone = (dateInMilliSec, timezone) => {
  const date = new Date(dateInMilliSec);
  if (timezone === undefined || timezone === null) {
    timezone = 'UTC';
  }
  return dateOnlyFormatter(timezone).format(date);
};

export function formatDateTimeWithTimeZone(timestamp, timeZone = 'America/Los_Angeles') {
  const date = new Date(timestamp);
  const options = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: true,
    timeZone: timeZone,
    timeZoneName: 'short',
  };

  // D/M/YYYY, hh:mm:ss AM PST
  const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);
  return formattedDate;
}

export function getISOStringFromDate(timestamp) {
  if (isNaN(timestamp)) {
    return '';
  }
  const date = new Date(timestamp);

  // YYYY-MM-DD
  return date.toISOString().substring(0, 10);
}
